module.exports = __webpack_public_path__ + "ce7e20aed6b59b612b33309980f64063.png";